import "./StoreBanner.scss"


export default function Menu( props ) {
    return (
        <div className="StoreBannerContainer">
            <div className="ContactsContainer">
                <div className="PhoneNumber">
                    <div>
                        Call for <span className='bold'>PICK-UP</span> or <span className='bold'>Delivery</span>
                        <br/>
                        <span className="no-wrap">(201) 272-6424</span>
                    </div>
                </div>
                <br/>
                <div className="Address">
                    <div>
                        <span className='bold'>Located</span> at:
                        <br/>
                        280 Central Ave, Jersey City, NJ 07307
                    </div>
                </div>
            </div>
            
            <div className="Background">
                <div className="StoreBanner">
                    <div className="Text">
                        <h1>
                            What we do
                        </h1>
                        <br/>
                        <p>
                            We cook peruvian dishes for you, as you enjoy the modern and entertaining atmosphere we provide at Sabor a Peru.
                        </p>
                    </div>
                </div>
            </div>
            <div className="Gallary"/>
        </div>
    )
}